import { TelemetrySparklineSvg } from '@/components/telemetry/TelemetrySparklineSvg';

/**
 * Desktop-only "Live Vitals" sidebar panel for the Coach page.
 * Displays CTL/ATL/TSB summary with sparklines while chatting.
 */
export function LiveVitalsPanel() {
  // Static demo data — replace with real UserStats when available
  const vitals = [
    {
      label: 'BASE',
      sublabel: 'Aerobic Base',
      value: '62.4',
      unit: '',
      trend: 'up' as const,
      color: '#00FFC8',
      sparkline: [0.3, 0.35, 0.4, 0.42, 0.48, 0.52, 0.55, 0.58, 0.6, 0.62],
    },
    {
      label: 'LOAD',
      sublabel: 'Recent Load',
      value: '71.8',
      unit: '',
      trend: 'up' as const,
      color: 'hsl(35, 90%, 55%)',
      sparkline: [0.5, 0.55, 0.6, 0.58, 0.65, 0.7, 0.68, 0.72, 0.7, 0.72],
    },
    {
      label: 'FRESH',
      sublabel: 'Freshness Index',
      value: '-9.4',
      unit: '',
      trend: 'down' as const,
      color: 'hsl(200, 70%, 55%)',
      sparkline: [0.5, 0.45, 0.4, 0.42, 0.38, 0.35, 0.33, 0.3, 0.28, 0.3],
    },
  ];

  return (
    <div className="w-64 shrink-0 border-l border-white/[0.06] bg-white/[0.02] backdrop-blur-sm p-4 flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-1.5 rounded-full bg-[#00FFC8] shadow-[0_0_6px_rgba(0,255,200,0.6)] animate-pulse" />
        <span className="font-mono text-[10px] uppercase tracking-[0.12em] text-muted-foreground/60">
          Live Vitals
        </span>
      </div>

      {/* Vital cards */}
      {vitals.map((v) => (
        <div
          key={v.label}
          className="rounded-lg border border-white/[0.08] bg-white/[0.03] p-3"
        >
          <div className="flex items-center justify-between mb-2">
            <div>
              <span className="font-mono text-[9px] uppercase tracking-[0.1em] text-muted-foreground/50">
                {v.sublabel}
              </span>
              <div className="flex items-baseline gap-1">
                <span className="font-mono text-lg font-medium" style={{ color: v.color }}>
                  {v.value}
                </span>
                <span className="font-mono text-[10px] text-muted-foreground/40">
                  {v.label}
                </span>
              </div>
            </div>
            <div
              className={`font-mono text-[9px] px-1.5 py-0.5 rounded ${
                v.trend === 'up'
                  ? 'text-[#00FFC8] bg-[#00FFC8]/10'
                  : v.trend === 'down'
                    ? 'text-[hsl(35,90%,55%)] bg-[hsl(35,90%,55%)]/10'
                    : 'text-muted-foreground bg-muted/10'
              }`}
            >
              {v.trend === 'up' ? '▲' : v.trend === 'down' ? '▼' : '—'}
            </div>
          </div>
          <TelemetrySparklineSvg
            data={v.sparkline}
            width={200}
            height={28}
            stroke={v.color}
            className="w-full"
          />
        </div>
      ))}

      {/* System status */}
      <div className="mt-auto pt-4 border-t border-white/[0.06]">
        <div className="flex items-center justify-between">
          <span className="font-mono text-[9px] uppercase tracking-[0.1em] text-muted-foreground/40">
            System Status
          </span>
          <span className="font-mono text-[9px] text-[#00FFC8]">NOMINAL</span>
        </div>
      </div>
    </div>
  );
}
